module.exports = __webpack_public_path__ + "d125f5c2f9b06cf15ced0554b646966f.png";